import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAppointmentInRange,
  getAppointmentsCalendar,
} from "../../../../actions/accidentDashboard";
import { clearSupportAppointments, getSupportAppointments } from "../../../../actions/appointments";
import { getArts } from "../../../../actions/arts";
import { clearWsmlartXmlPreview, getWsmlartXmlPreview } from "../../../../actions/connectivityResponse";
import { changeSelectProvider, clearAllProviders, getAllProviders } from "../../../../actions/providers";
import { convertDateTimeToNet } from "../../../../utils/datetimeUtils";
import snackbarUtils from "../../../../utils/snackbarUtils";
import ConfirmDialog from "../../../commons/dialog/confirmDialog";
import XmlViewerDialog from "../../../commons/dialog/xmlViewerDialog";
import AppointmentDetail from "../../accident/accidentDashboard/appointmentsCalendar/detail/appointmentDetail";
import AppointmentsSearchForm from "./appointmentsSearchForm";
import AppointmentsTable from "./appointmentsTable";

const estados = [
  { id: 0, nombre: "TODOS" },
  { id: 1, nombre: "NO INFORMADOS" },
  { id: 2, nombre: "AUSENTES" },
  { id: 3, nombre: "PRESENTES" },
  { id: 4, nombre: "ANULADOS" },
  { id: 5, nombre: "PROGRAMADOS" },
];

const initialValues = {
  art: "",
  siniestro: "",
  dni: "",
  providerId: "",
  state: "",
  datePeriod: "all",
  startDate: null,
  endDate: null,
};

const AppointmentsSearchContainer = () => {
  const dispatch = useDispatch();
  const providers = useSelector((state) => state.providers.allProvidersOptions);
  const arts = useSelector((state) => state.arts);
  const supportAppointments = useSelector((state) => state.appointments.supportAppointments);
  const wsmlartXmlPreview = useSelector((state) => state.connectivityResponse.wsmlartXmlPreview);
  const documentation = useSelector((state) => state.accidentDashboard.availableDocumentsToAdd);

  const [selectedRows, setSelectedRows] = useState([]);
  const [idArt, setIdArt] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [appointmentsSelected, setAppointmentsSelected] = useState([]);
  const [openDetail, setOpenDetail] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [appointment, setAppointment] = useState({});
  const [openXmlDialog, setOpenXmlDialog] = useState(false);
  const [xmlFilename, setXmlFilename] = useState("wsmlart_turno.xml");

  const loading = arts.isFetching;
  const tableLoading = supportAppointments.isFetching;

  const cargaFPT = documentation.data.find((f) => f.formulario === "Fpt")
    ? true
    : false;

  useEffect(() => {
    clearAllProviders();
    if (!arts.list.length) {
      dispatch(getArts());
    }
    return () => {
      dispatch(changeSelectProvider(false));
    };
  }, [dispatch]);

  const handleCloseConfirmDialog = () => {
    setConfirmDialogOpen(false);
  };

  const handleOpenXmlPreview = (appointmentToPreview) => {
    if (!appointmentToPreview?.idTurnoSiniestro) {
      snackbarUtils.error("No se encontraron datos para generar el XML del turno.");
      return;
    }

    setXmlFilename(`wsmlart_turno_${appointmentToPreview.idTurnoSiniestro}.xml`);
    dispatch(
      getWsmlartXmlPreview(
        appointmentToPreview.mlCloudCoreArtId,
        appointmentToPreview.idSiniestro,
        undefined,
        "TURNO",
        appointmentToPreview.idTurnoSiniestro,
      ),
    );
    setOpenXmlDialog(true);
  };

  const handleCloseXmlPreview = () => {
    setOpenXmlDialog(false);
    dispatch(clearWsmlartXmlPreview());
  };

  const handleCloseEdit = () => {
    setAppointment({});
    setOpenEdit(false);
  };

  const handleOpenEdit = (appointment) => {
    setAppointment(appointment);
    setOpenEdit(true);
  };
  const handleClearOpenFromForm = () => {
    dispatch(clearAppointmentInRange());
    setAppointmentsSelected([]);
  };
  const handleCloseDetail = () => {
    setOpenDetail(false);
    handleClearOpenFromForm();
  };

  const handleOpenConfirmDialog = () => {
    setConfirmDialogOpen(true);
  };

  const handleSubmitSearch = (values) => {
    const queryParams = {
      art: values.art,
      state: values.state,
      startDate: convertDateTimeToNet(values.startDate),
      endDate: convertDateTimeToNet(values.endDate),
      siniestro: values.siniestro,
      dni: values.dni,
      providerId: values.provider,
    };
    dispatch(getSupportAppointments(queryParams));
  };

  const handleAppointmentDetail = (appointment) => {
    dispatch(changeSelectProvider(appointment.idPrestador, true));

    dispatch(
      getAppointmentsCalendar(
        appointment.idSiniestro,
        appointment.mlCloudCoreArtId,
        true,
      ),
    );

    setAppointmentsSelected([appointment]);
    setAppointment(appointment);
    setOpenDetail(true);
  };
  const handleCloseAllDetails = () => {
    handleClearOpenFromForm();
    handleCloseDetail();
    handleCloseEdit();
    handleCloseConfirmDialog();
  };

  const handleArtChange = (artValue) => {
    if (artValue) {
      dispatch(getAllProviders(artValue));
    } else {
      dispatch(clearAllProviders());
    }
  };

  const handleClearSearch = () => {
    dispatch(clearSupportAppointments());
  }

  return (
    <>
      <AppointmentsSearchForm
        isSearching={loading}
        arts={arts.list}
        providers={providers.data}
        estados={estados}
        initialValues={initialValues}
        handleSubmitSearch={handleSubmitSearch}
        setIdArt={setIdArt}
        onArtChange={handleArtChange}
        handleClearSearch={handleClearSearch}
      />
      <AppointmentsTable
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        estados={estados}
        namesArts={arts.shortNameArt}
        data={supportAppointments.data}
        handleAppointmentDetail={handleAppointmentDetail}
        handleOpenXmlPreview={handleOpenXmlPreview}
        loading={tableLoading}
      />
      <AppointmentDetail
        data={appointmentsSelected}
        open={openDetail}
        handleClose={handleCloseDetail}
        handleOpenConfirmDialog={handleOpenConfirmDialog}
        openEdit={openEdit}
        handleOpenEdit={handleOpenEdit}
        handleCloseEdit={handleCloseEdit}
        appointment={appointment}
        cargaFPT={cargaFPT}
        idArt={idArt}
      />
      <div>
        <ConfirmDialog
          open={confirmDialogOpen}
          handleClose={handleCloseConfirmDialog}
          handleConfirm={handleCloseAllDetails}
          title="CERRAR VENTANA"
          text="¿Está seguro que desea cancelar esta operación? En caso de aceptar, se perderá la información ingresada"
        />
      </div>
      <XmlViewerDialog
        open={openXmlDialog}
        onClose={handleCloseXmlPreview}
        xml={wsmlartXmlPreview?.data?.documentoXml}
        loading={wsmlartXmlPreview?.isFetching}
        title="Visualizar XML"
        filename={xmlFilename}
      />
    </>
  );
};

export default AppointmentsSearchContainer;
